import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';


const INITIAL_STATE_MANAGE_DATES = {
  'manageDates': [],
  'loading': false,
};

export const budgets = (state, action) => {
  return createReducer(INITIAL_STATE_MANAGE_DATES, {
    [ActionTypes.FETCHING_BUDGETS_DATES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_BUDGETS_DATES]: (state, action) => ({
      ...state,
      'loading': false,
      'manageDates': action.response.data,
    }),
    [ActionTypes.FETCHED_BUDGETS_DATES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'manageDates': [],
    }),
    [ActionTypes.DELETING_BUDGET_DATE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DELETED_BUDGET_DATE]: (state, action) => {
      return {
        ...state,
        'loading': false,
        'manageDates': state.manageDates.filter((date) => date.id !== action.id),
      };
    },
    [ActionTypes.DELETE_BUDGET_DATE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
